import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

export default function Footer() {
  const { pages } = useSite();
  return (
    <footer className="border-t border-[#E8DCCB] bg-[#FFF3F8]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 flex flex-col md:flex-row items-start justify-between gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/logo-transparent.png" alt="Business Aligned" className="w-14 h-14 object-contain" />
            <span className="f-display font-medium tracking-tight text-lg">Business <span className="f-serif text-[#A8785A]">Aligned</span></span>
          </div>
          <p className="text-sm text-[#8C7562] max-w-xs leading-relaxed">
            Every thought your business needs — organized, branded, and ready to launch.
          </p>
        </div>
        <div className="flex gap-16">
          <div className="flex flex-col gap-3">
            <span className="eyebrow">Tools</span>
            <Link to="/organizer" className="text-sm text-[#8C7562] hover:text-[#3A2E25] transition-colors" data-testid="footer-link-organizer">The Organizer</Link>
            {pages.websites && <Link to="/websites" className="text-sm text-[#8C7562] hover:text-[#3A2E25] transition-colors" data-testid="footer-link-websites">Websites</Link>}
            {pages.social && <Link to="/social" className="text-sm text-[#8C7562] hover:text-[#3A2E25] transition-colors" data-testid="footer-link-social">Social Media</Link>}
            {pages.two_point_oh && <Link to="/2-0" className="text-sm text-[#8C7562] hover:text-[#3A2E25] transition-colors" data-testid="footer-link-two-point-oh">Business Aligned 2.0</Link>}
          </div>
          <div className="flex flex-col gap-3">
            <span className="eyebrow">Get in touch</span>
            <Link to={pages.social ? "/social#inquire" : "/inquire"} className="text-sm text-[#8C7562] hover:text-[#3A2E25] transition-colors" data-testid="footer-link-inquire">Send an inquiry</Link>
            <Link to="/policies" className="text-sm text-[#8C7562] hover:text-[#3A2E25] transition-colors" data-testid="footer-link-policies">Terms & Policies</Link>
            <span className="f-mono text-xs text-[#B9A896]">REPLIES WITHIN ONE BUSINESS DAY</span>
          </div>
        </div>
      </div>
      <div className="border-t border-[#E8DCCB] py-5 text-center f-mono text-[10px] tracking-[0.25em] text-[#B9A896] uppercase">
        © 2026 Business Aligned — Crafted with vector precision
      </div>
    </footer>
  );
}
